import * as z from "zod";
import { destinationSchema } from "./egressRouteShared";
import { mutator } from "./mutator";

export const updateEgressRuleSchema = z.object({
  id: z.string(),
  destination: destinationSchema,
  // Omitted/null matches any port.
  port: z.number().int().min(1).max(65535).nullish(),
  action: z.enum(["allow", "deny"]),
});

export const updateEgressRule = mutator({
  schema: updateEgressRuleSchema,
  resolve: {
    rule: { kind: "egressRule", from: "id" },
  },
  permissions: [
    {
      permission: "tenant:egress_rules_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
  ],
  fn: async ({ tx, args: { rule, destination, port, action } }) => {
    await tx.mutate.egressRules.update({
      id: rule.id,
      destinationType: destination.type,
      destination:
        destination.type === "cidr" ? destination.range : destination.pattern,
      port: port ?? null,
      action,
    });
  },
});
